<template>
  <tr tabindex="0">
    <td
      class="cursor-move hover:outline-dashed hover:outline-offset-[-1px] hover:outline-gray-100"
      :class="{
        'outline-dashed outline-offset-[-1px] outline-gray-100': dragging,
      }"
    >
      <table
        role="presentation"
        cellpadding="0"
        cellspacing="0"
        style="border-collapse: collapse; border-spacing: 0px"
        :align="align"
        border="0"
      >
        <tbody>
          <tr>
            <td :key="tdStyleKey" :style="tdStyle">
              <div :style="divStyle" v-html="block.content"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>

<script lang="ts" setup>
  import { StyleValue, computed } from "vue";

  const props = defineProps({
    block: {
      type: Object,
      required: true,
    },
    sectionIndex: {
      type: Number,
      required: true,
    },
    columnIndex: {
      type: Number,
      required: true,
    },
    blockIndex: {
      type: Number,
      required: true,
    },
    loopColumnIndex: {
      type: Number,
      required: true,
    },
    loopBlockIndex: {
      type: Number,
      required: true,
    },
    dragging: {
      type: Boolean,
      default: false,
    },
  });

  const align = computed(() => {
    return props.block.attributes[`align`];
  });

  const divStyle = computed<StyleValue>(() => {
    return {
      "word-break": "break-word",
      fontSize: props.block.attributes[`font-size`],
      fontFamily:
        props.block.attributes[`font-family`] || "Helvetica, Arial, sans-serif",
      color: props.block.attributes[`color`],
      textDecoration: props.block.attributes[`text-decoration`],
      textTransform: props.block.attributes[`text-transform`],
      letterSpacing: props.block.attributes[`letter-spacing`],
      fontStyle: props.block.attributes[`font-style`],
      fontWeight: props.block.attributes[`font-weight`],
      textAlign: props.block.attributes[`align`],
      lineHeight: props.block.attributes[`line-height`] || 1,
    };
  });

  const tdStyle = computed<StyleValue>(() => {
    return {
      "word-break": "break-word",
      padding: props.block.attributes[`padding`]
        ? props.block.attributes[`padding`]
        : "0px 0px 0px 0px",
      textAlign: props.block.attributes[`align`],
    };
  });

  const tdStyleKey = computed(() => {
    return JSON.stringify(divStyle.value);
  });
</script>
